import React from 'react';
import { motion } from 'motion/react';
import { Feature } from './featureData';

interface FeatureCardProps {
  feature: Feature;
  index: number;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ feature, index }) => {
  const Icon = feature.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      whileHover={{ y: -6, transition: { duration: 0.3 } }}
      className="group relative flex flex-col h-full bg-surface hover:bg-surface-lowest border border-outline/10 rounded-2xl p-6 transition-all duration-300 shadow-sm hover:shadow-xl hover:shadow-primary/5 hover:border-primary/20 overflow-hidden"
    >
      {/* Subtle border glow on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

      <div className="flex items-start justify-between mb-4 relative z-10">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-on-primary transition-colors duration-300">
          <Icon className="w-6 h-6 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.5} />
        </div>
        
        {feature.isComingSoon && (
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-semibold bg-surface-variant text-on-surface-variant border border-outline/10 uppercase tracking-wider">
            Coming Soon
          </span>
        )}
      </div>

      <h3 className="text-lg font-semibold text-on-surface mb-2 relative z-10 transition-colors duration-300 group-hover:text-primary">
        {feature.title}
      </h3>
      
      <p className="text-sm text-on-surface-variant leading-relaxed relative z-10">
        {feature.description}
      </p>
    </motion.div>
  );
};
